import { createSelector } from 'reselect';

export const CORE_STATE_ROOT = '@manakin/core';

export const getCoreState = (state) => state[CORE_STATE_ROOT];
